import React from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import ExpensesPage from './pages/ExpensesPage';
import ExpensePage from './pages/ExpensePage';
import NewExpensePage from './pages/NewExpensePage';

const routes: RouteObject[] = [
  {
    index: true,
    element: <ExpensesPage />,
  },
  {
    path: 'new',
    element: <NewExpensePage />,
  },
  {
    path: ':id',
    children: [
      {
        index: true,
        element: <Navigate to="details" replace />,
      },
      {
        path: ':tab',
        element: <ExpensePage />,
      },
    ],
  },
];

export default routes;
